export const contactTabs = [
  {
    label: "Customer",
    value: "customers",
    index: 0,
  },
  {
    label: "Supplier/Vendor",
    value: "suppliers",
    index: 1,
  },
  {
    label: "Transport",
    value: "transport",
    index: 2,
  },
];
